import PropTypes from "prop-types";
import React, { useState } from "react";
import RejectedIcon from "../../../../assets/assets/nip-rejected.svg";
import Button from "../../../Button/Button";
import UpdateDocs from "./UpdateDocs";

const Rejected = (props) => {
  const {
    id,
    uploadedFiles,
    success,
    submitValues,
    isSubmitting,
    getSingleApplication,
    reason,
    documents,
    userType,
  } = props;

  const [state, setState] = useState({
    showUpdate: false,
  });

  const goToUpdate = () => {
    setState({
      ...state,
      showUpdate: true,
    });
  };

  return (
    <div>
      {!state.showUpdate ? (
        <div>
          <div className="nip-integration-header">Document Upload</div>
          <div className="doc-pending">
            <div className="middle-box">
              <div className="middle-box-image">
                <img src={RejectedIcon} alt="rejected icon" />
              </div>
              <div className="middle-box-title">Documents Rejected</div>
              <span className="middle-box-subtitle">
                Opps!! Your document has been rejected. <br /> Reason: {reason}
              </span>

              <Button
                type="submit"
                height="50px"
                testId="goToUpdate"
                disabled={userType === "company_network_manager"}
                text="UPDATE DOCUMENT"
                onClick={goToUpdate}
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <UpdateDocs
            id={id}
            documents={documents}
            uploadedFiles={uploadedFiles}
            success={success}
            submitValues={submitValues}
            isSubmitting={isSubmitting}
            getSingleApplication={getSingleApplication}
          />
        </div>
      )}
    </div>
  );
};

Rejected.propTypes = {
  documents: PropTypes.any,
  getSingleApplication: PropTypes.any,
  id: PropTypes.any,
  isSubmitting: PropTypes.any,
  reason: PropTypes.any,
  submitValues: PropTypes.any,
  success: PropTypes.any,
  uploadedFiles: PropTypes.any,
  userType: PropTypes.string,
};

export default Rejected;
